import { createAction, props } from '@ngrx/store';
import { ConfirmRequest, SectionResponse, PaginatedApiResponseWithFilters, OverlapFiltersResponse } from '../../../api';
import { BaseOffersAndBookingsListPayloadInterface } from '../../modules/offers-and-bookings/_interfaces/base-offers-and-bookings-list-payload.interface';
import { BaseConfirmPspOfferPayloadInterface } from '../../apps-shared/_interfaces/base-confirm-psp-offer-payload.interface';

// Offer overlaps list
export const loadOfferOverlapsList = createAction(
  '[Bookings and Offers] Load offer overlaps list',
  props<{ payload: BaseOffersAndBookingsListPayloadInterface }>()
);
export const setOfferOverlapsList = createAction(
  '[Bookings and Offers] Set offer overlaps list',
  props<{
    payload: PaginatedApiResponseWithFilters & {
      data?: Array<SectionResponse>;
      filters?: OverlapFiltersResponse;
    };
  }>()
);
export const successOfferOverlapsList = createAction('[Bookings and Offers] Success offer overlaps list');
export const errorOfferOverlapsList = createAction('[Bookings and Offers] Error offer overlaps list');

// Confirm psp inquiry offer
export const confirmPspInquiryOffer = createAction(
  '[Bookings and Offers] Confirm psp inquiry offer',
  props<{ payload: BaseConfirmPspOfferPayloadInterface }>()
);
export const confirmPspInquiryOfferSuccess = createAction('[Bookings and Offers] Confirm psp inquiry offer success');
export const confirmPspInquiryOfferError = createAction('[Bookings and Offers] Confirm psp inquiry offer error');

// Withdraw psp inquiry offer
export const withdrawPspInquiryOffer = createAction(
  '[Bookings and Offers] Withdraw psp inquiry offer',
  props<{ payload: { inquiry: number; offer: number; isInquiryOffersPage?: boolean } }>()
);
export const withdrawPspInquiryOfferSuccess = createAction('[Bookings and Offers] Withdraw psp inquiry offer success');
export const withdrawPspInquiryOfferError = createAction('[Bookings and Offers] Withdraw psp inquiry offer error');
